import { Button, Container, Header, SpaceBetween } from '@amzn/awsui-components-core';
import { ContentWorkflow } from '@amzn/awscat-pattern-library-service-model';
import React, { useState } from 'react';
import DeleteContentButton from '../../content/DeleteContentButton';

interface Props {
  workflow: ContentWorkflow;
  header?: string;
  onSave?: (postId?: string) => Promise<void>;
  onPreview?: (postId?: string) => void;
  onExitPreview?: (postId?: string) => void;
  onDelete?: (postId: string) => Promise<void>;
  onPublish?: (postId: string) => Promise<void>;
  autoSavingEnabled?: boolean;
}

const PostControls = (props: Props) => {
  const {
    workflow,
    header,
    onSave,
    onPreview,
    onExitPreview,
    onDelete,
    onPublish,
    autoSavingEnabled,
  } = props;
  const [isSaving, setIsSaving] = useState(false);
  const [isPublishing, setIsPublishing] = useState(false);
  const [isPreview, setIsPreview] = useState(false);
  const postId = workflow?.contentId;

  const saveDraft = async () => {
    setIsSaving(true);
    try {
      // @ts-expect-error TS2722 - strict migration
      await onSave(postId);
    } finally {
      setIsSaving(false);
    }
  };

  const previewPost = () => {
    setIsPreview(true);
    return onPreview && onPreview();
  };

  const exitPreview = () => {
    setIsPreview(false);
    return onExitPreview && onExitPreview();
  };

  const deletePost = async () => {
    // @ts-expect-error TS2722 - strict migration
    await onDelete(postId);
  };

  const publishPost = async () => {
    setIsPublishing(true);
    try {
      // @ts-expect-error TS2722 - strict migration
      await onPublish(postId);
    } finally {
      setIsPublishing(false);
    }
  };

  const previewButton = isPreview ? (
    <Button onClick={exitPreview}>Exit preview</Button>
  ) : (
    <Button onClick={previewPost}>Preview</Button>
  );

  return (
    <Container
      header={<Header variant="h3">{header}</Header>}
      footer={autoSavingEnabled ? 'Footer' : null}
    >
      <SpaceBetween className="full-width-button" direction="vertical" size="s">
        <Button loading={isSaving} onClick={saveDraft}>
          Save draft
        </Button>
        {previewButton}
        {workflow && (
          <DeleteContentButton workflow={workflow} onDeleteContent={deletePost} variant="normal" />
        )}
        {workflow && (
          <Button loading={isPublishing} onClick={publishPost} variant="primary">
            Publish
          </Button>
        )}
      </SpaceBetween>
    </Container>
  );
};

export default PostControls;
